<div echarts [options]="options" [merge]="mergeOptions" class="demo-chart"></div>